import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/bootstrap': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M333.5 201.4c0 23.6-18.1 36.8-50.9 36.9h-42.5v-71.2h50.4c27.4 0 43 12.2 43 34.3zM517 188.6c9.5 31 25.7 50.6 52 53.1v28.5c-26.4 2.5-42.5 22.1-52.1 53.1-9.5 30.9-10.8 68.8-9.8 98.1 1.1 30.4-22.6 58.5-54.7 58.5h-328.7c-32 0-55.8-28-54.7-58.5 1.1-29.3-0.3-67.2-9.8-98.1-9.6-31-25.8-50.6-52.2-53.1v-28.5c26.5-2.5 42.6-22.1 52.2-53.1 9.5-30.9 10.8-68.8 9.8-98.1-1.1-30.4 22.6-58.5 54.7-58.5h328.8c32 0 55.8 28 54.7 58.5-1.1 29.3 0.3 67.2 9.8 98.1zM300.2 375.1c51.9 0 83.2-25.4 83.2-67.5 0-31.7-22.3-54.7-55.5-58.3v-1.3c24.4-3.9 43.5-26.5 43.5-51.8 0-36-28.4-59.4-71.7-59.4h-97.4v238.3h97.9zM290.2 266.4c35.9 0 54.5 13.2 54.5 38.9 0 25.8-18.1 39.5-52.3 39.5h-52.3v-78.4h50.1z'
      }
    ]
  }
})
